module.exports = __webpack_public_path__ + "img/about_02.8ecd4efc.jpg";